module.exports = __webpack_public_path__ + "static/img/bt1.b315d79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cockpitCh/bt1.png
// module id = 9x8S
// module chunks = 31